import { StudyTestRecommendation } from '../../../contracts/recommendation/recommendation-model';
import { RecommendedResult } from '../../../contracts/recommendation/recommended-result-model';

export interface IRecommendationState {
    recommendationCount: number;
    recommendations: StudyTestRecommendation[];
    selectedStudyTestRecommendation: StudyTestRecommendation;
    selectedRecommendation: RecommendedResult;
}

const initialState: IRecommendationState = {
    recommendationCount: 0,
    recommendations: null,
    selectedStudyTestRecommendation: null,
    selectedRecommendation: null
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/recommendation/IRecommendationState.ts